let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gOTEJ")).then(() => parcelRequire('jbgs6'));